import { useTeamConfig } from "../hooks/useTeamConfig";
import Head from "next/head";
import { useTranslation } from "react-i18next";

export function FaviconProvider() {
  const { images, browserTitle } = useTeamConfig();
  const { t } = useTranslation();

  return (
    <Head>
      <title>{t("teamGlobal.browserTitle") || browserTitle}</title>
      <link
        id="favicon_link"
        rel="icon"
        type="image/png"
        href={images.faviconImage}
      />
    </Head>
  );
}
